import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Link,
  styled,
  Typography,
} from '@mui/material';
import { ComponentProps } from 'react';
import CreditsAmountSlider from '../../../MyApps/components/CreditsAmountSlider';

export const StyledCard = styled(Card)(({ theme }) => ({
  padding: theme.spacing(5),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  borderRadius: theme.spacing(1),
  outline: '2px solid',
  outlineColor: '#c1c8ff',
  '.MuiCardHeader-action': {
    background: '#e0e4ff',
    padding: theme.spacing(0.5, 1.5),
    borderRadius: '16px',
    color: '#414778',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '20px',
    marginTop: theme.spacing(0.25),
  },
}));

export const StyledCardHeader = styled(CardHeader)(({ theme }) => ({
  padding: 0,
  '.MuiCardHeader-content': {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },
  '.MuiCardHeader-title': {
    fontWeight: 700,
    fontSize: theme.spacing(2.5),
    lineHeight: theme.spacing(3.5),
  },
  '.MuiCardHeader-subheader': {
    color: '#4b5563',
  },
}));

export const StyledCardContent = styled(CardContent)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  padding: 0,
}));

export const StyledSlider = styled(CreditsAmountSlider)(() => ({}));

export const StyledButtonBase = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'component',
})(({ theme }) => ({
  fontFamily: '"Inter", sans-serif',
  fontSize: '1rem',
  width: '100%',
  color: '#6d77c8',
  border: '2px solid',
  borderColor: '#6d77c8',
  textTransform: 'none',
  lineHeight: '24px',
  padding: theme.spacing(1.5, 2.5),
  borderRadius: theme.spacing(4),
  '&.MuiButton-root': {
    marginLeft: 0,
  },
  '.MuiButton-loadingIndicator': {
    color: '#ffffff',
  },
  '&:hover': {
    background: '#6d77c8',
    color: '#ffffff',
  },
}));

export const StyledButton = (
  props: ComponentProps<typeof StyledButtonBase>
  // @ts-expect-error component actually exists
) => <StyledButtonBase component={Link} {...props} />;

export const StyledCardActions = styled(CardActions)(({ theme }) => ({
  flexDirection: 'column',
  flex: 1,
  gap: theme.spacing(2),
  justifyContent: 'space-between',
}));

export const StyledPurchaseNotice = styled(Typography)(() => ({
  fontFamily: '"Inter", sans-serif',
  fontSize: '14px',
}));
